import { stripeApi } from '../firebase/functionsService';
import { getStripe } from './client';

// Feil vi selv lager her, med meldinger skrevet for bestilleren.
const OWN_ERROR_CODES = ['payment/confirmation-failed', 'payment/unavailable'];

function paymentError(code, message) {
  return Object.assign(new Error(message), { code });
}

// Aksepterer et bud. Serveren reserverer beløpet før oppdraget tildeles.
// Krever banken 3D Secure, viser Stripe bankens bekreftelse, og tildelingen fullføres etterpå.
// attemptId er nytt per kall, men felles for begge serverkallene, så serveren kan skille forsøk fra hverandre.
export async function acceptBidWithPayment({ orderId, bidId, expectedAmount, isTestAccount }) {
  const attemptId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const first = await stripeApi.acceptBid({ orderId, bidId, expectedAmount, attemptId });
  if (first.status !== 'requires_action') return first;

  const stripe = await getStripe(isTestAccount);
  if (!stripe) {
    throw paymentError('payment/unavailable', 'Betaling er ikke tilgjengelig akkurat nå. Prøv igjen senere.');
  }

  const { error } = await stripe.handleNextAction({ clientSecret: first.clientSecret });
  if (error) {
    throw paymentError('payment/confirmation-failed', 'Betalingen ble ikke bekreftet hos banken. Prøv igjen eller bruk et annet kort.');
  }

  const result = await stripeApi.acceptBid({ orderId, bidId, expectedAmount, attemptId, paymentIntentId: first.paymentIntentId });
  if (result.status !== 'matched') {
    throw paymentError('payment/confirmation-failed', 'Betalingen ble ikke bekreftet hos banken. Prøv igjen eller bruk et annet kort.');
  }
  return result;
}

// Serverens failed-precondition-meldinger er skrevet for bestilleren; andre feil får en generell tekst.
export function acceptBidErrorMessage(err) {
  if (err?.code === 'functions/failed-precondition' || OWN_ERROR_CODES.includes(err?.code)) {
    return err.message;
  }
  return 'Kunne ikke akseptere bud. Prøv igjen.';
}
